import hooks from './shipment-quote-offers.hooks';
import createSchema from './shipment-quote-offers.schema';

export default (app) => {
  const service = app.service('api/shipment-quote-offers');
  service.schema = createSchema(app);
  service.hooks(hooks);
};
